export const formatPrice = (price) => {
    return (price || 0).toLocaleString('en-US', {
            minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export const format$Price = (price, showPlus = false) =>{ 
    return price>=0
        ? `${showPlus?'+':''}$ ${formatPrice(price)}`
        : `-$ ${formatPrice(-price)}`
}